import { render } from "./IconHamburgerMenu.vue?vue&type=template&id=207093a9"
const script = {}

import "./IconHamburgerMenu.vue?vue&type=style&index=0&id=207093a9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__